import React, { useState } from "react";
import { useSnackBar } from "../../../hooks/useSnackBar";
import "./NewsLetter.css";

// components imports
import Unit from "../NewsLetter/Components/Unit/Unit";
import Currency from "../NewsLetter/Components/Currency/Currency";
import Subscribers from "./Components/Subscribers/Subscribers";
import LandingCompanyDetails from "./Components/LandingCompanyDetails/LandingCompanyDetails";
import Blogs from "./Components/Blogs/Blogs";
import Messages from "./Components/Messages/Messages";

// apis imports
// library imports
import TabsComponent from "../../../Components/Common/TabsComponent";
import { useTranslation } from "react-i18next";

const NewsLetter = () => {
  const { t } = useTranslation("admin");
  const [tab, setTab] = useState(0);
  const setSnack = useSnackBar();

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <div
      className="dispatcher__screen"
      style={{ maxWidth: "100%", padding: "0px 5px" }}
    >
      <TabsComponent
        items={[
          {
            label: t("newsletter.subscribers"),
            value: 0,
          },
          { label: t("newsletter.blogs"), value: 1 },
          { label: t("newsletter.landingCompanyDetails"), value: 2 },
          { label: t("newsletter.messages"), value: 3 },
          { label: t("newsletter.unit"), value: 4 },
          { label: t("newsletter.currency"), value: 5 },
        ]}
        tab={tab}
        handleTabChange={handleTabChange}
      />
      {tab === 0 && <Subscribers setSnack={setSnack} />}
      {tab === 1 && <Blogs setSnack={setSnack} />}
      {tab === 2 && <LandingCompanyDetails setSnack={setSnack} />}
      {tab === 3 && <Messages setSnack={setSnack} />}
      {tab === 4 && <Unit setSnack={setSnack} />}
      {tab === 5 && <Currency setSnack={setSnack} />}
    </div>
  );
};

export default NewsLetter;
